import { Event, EventStatus } from '../../types/interfaces/Event'
import { User } from 'modules/user/types'
import { Team } from '../../types/interfaces/Team'
import { EventScore } from '../../types/interfaces/EventScore'
import { MediaAssetType } from '../../types/interfaces/MediaAsset'
import { nowUtc, utcToZonedDate } from '../date'
import { EventPlayout } from 'modules/events/types'

export const getEventStatusString = (eventCode: EventStatus) => {
  switch (eventCode) {
    case EventStatus.LIVE:
      return 'live'
    case EventStatus.VOD:
      return 'vod'
    case EventStatus.UPCOMING:
      return 'upcoming'
    case EventStatus.TECHNICAL_ISSUE:
      return 'technical_issue'
    default:
      return 'unknown'
  }
}

export const getMediaTypeByEventStatus = (
  eventCode: EventStatus
): MediaAssetType | null => {
  switch (eventCode) {
    case EventStatus.LIVE:
      return 'broadcast_live'
    case EventStatus.VOD:
      return 'broadcast_vod'
    default:
      return null
  }
}

export const isPurchasable = (event: EventPlayout, user: User | undefined) => {
  return !event.free && (!user || (!!user && !!event.locked))
}

export const computeIsPlayable = (event: EventPlayout, timeZone: string) => {
  return (
    event.status === EventStatus.LIVE ||
    event.status === EventStatus.VOD ||
    utcToZonedDate(event.startTime, timeZone) <= nowUtc(timeZone)
  )
}

export const getScore = (
  eventScores: EventScore[] | undefined,
  eventTeams: Team[] | undefined
) => {
  const scores =
    eventScores &&
    eventScores?.map(score => {
      const team = eventTeams?.find(t => t.uuid === score.team.uuid)
      if (!team) return null

      const isHomeTeam = team.homeTeam
      const scoreText = `${score.score}`

      return { isHomeTeam, scoreText }
    })

  const homeTeamScore =
    scores?.find(score => score?.isHomeTeam)?.scoreText || '-'
  const awayTeamScore =
    scores?.find(score => !score?.isHomeTeam)?.scoreText || '-'

  return `${homeTeamScore}:${awayTeamScore}`
}

export const isUpcoming = (event: EventPlayout) => {
  return event.status === EventStatus.UPCOMING
}

